/* eslint-disable unicorn/prefer-module -- required from gatsby-browser.js */
const { LOCALES, getLocaleFromPath } = require('./locales');
const { PATHS } = require('./paths');

// GA4 content groups, keyed by the first path segment (after the locale prefix).
// Sent with every page_view so reports can answer "which section drives leads".
const CONTENT_GROUPS = {
    [PATHS.INDEX]: 'home',
    [PATHS.BLOG]: 'blog',
    [PATHS.SERVICES]: 'services',
    [PATHS.EXPERTISES]: 'expertises',
    [PATHS.TECHNOLOGIES]: 'technologies',
    [PATHS.SOLUTIONS]: 'solutions',
    [PATHS.RESOURCES]: 'resources',
    [PATHS.CASE_STUDIES]: 'case_studies',
    [PATHS.CAREERS]: 'careers',
    [PATHS.CONTACT_US]: 'contact',
    [PATHS.ESTIMATE_THE_PROJECT]: 'contact',
    [PATHS.TEAM]: 'company',
    [PATHS.OUR_PARTNERS]: 'company',
    [PATHS.SOFTWARE_DEVELOPMENT_PROCESS]: 'company',
    [PATHS.PRESS_RELEASE]: 'company',
    [PATHS.FUNDS_EU]: 'company',
};

const getPageContext = (pathname = '/') => {
    const locale = getLocaleFromPath(pathname);
    const segments = pathname.split('/').filter(Boolean);
    if (segments[0] && Object.values(LOCALES).includes(segments[0])) {
        segments.shift();
    }

    return {
        content_group: CONTENT_GROUPS[segments[0] ?? PATHS.INDEX] ?? 'other',
        content_language: locale,
    };
};

module.exports = { getPageContext };
